import {HttpService} from './HttpService';

export const OrdersHttpService = {
	getOrder(orderId) {
		return HttpService.get(`/orders/${orderId}`);
	}
};


// WEBPACK FOOTER //
// ./src/http/OrdersHttpService.js